<template>
  <div>
    <h1>嵌入本地 Vue 页面</h1>
    <iframe
      :src="iframeSrc"
      width="100%"
      height="800px"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
        iframeSrc: '/webview' 
    };
  },
};
</script>
<style lang="scss" scoped></style>
